import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Flex, Icon, Popover, StyledLink } from "orcs-design-system";
import { trackEvent } from "src/services/segment";
import { EVENT_TRACKING } from "src/consts/eventTracking";

const HelpIconPosition = styled.div`
  position: absolute;
  top: 5%;
  left: 90%;
`;

const PopOverContent = ({ href, text }) => (
  <>
    <Flex>
      <HelpIconPosition>
        <StyledLink
          href={href}
          target="_blank"
          onClick={() => {
            trackEvent(EVENT_TRACKING.URL_CLICKED, {
              action: "help_link_clicked",
            });
          }}
        >
          <Icon size="lg" icon={["far", "question-circle"]} />
        </StyledLink>
      </HelpIconPosition>
    </Flex>
    {text}
  </>
);

PopOverContent.propTypes = {
  href: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
};

const PopoverWithHelpLink = React.memo(
  ({ href, isVisible = true, text, children, ...props }) => {
    const popOverContent = <PopOverContent href={href} text={text} />;

    if (!isVisible) {
      return children;
    }

    return (
      <Popover text={popOverContent} withFocusControl={false} {...props}>
        {children}
      </Popover>
    );
  }
);

PopoverWithHelpLink.propTypes = {
  href: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
  text: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default PopoverWithHelpLink;
